import { render, staticRenderFns } from "./Spider.vue?vue&type=template&id=2072a1ca"
import script from "./Spider.vue?vue&type=script&lang=js"
export * from "./Spider.vue?vue&type=script&lang=js"
import style0 from "./Spider.vue?vue&type=style&index=0&id=2072a1ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports